import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export function usePricingElasticity(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'pricing', 'elasticity'],
    queryFn: async () => {
      const response = await apiClient.pricing.getElasticity(clientId!);
      return response.products;
    },
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}

export function usePortfolioPricing(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'pricing', 'portfolio'],
    queryFn: () => apiClient.pricing.getPortfolio(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useDemandCurve(clientId: string | undefined, gtin: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'pricing', 'demand-curve', gtin],
    queryFn: () => apiClient.pricing.getDemandCurve(clientId!, gtin!),
    enabled: !!clientId && !!gtin,
    staleTime: 5 * 60 * 1000,
  });
}
